import { Img } from "components";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useSpotlight } from 'react-spotlight-tour';
import Wrapper from "../components/Wrapper";
import axios from "axios";
import SuccessModal from "../Communication/SuccessModal";
import TypingInput from "../components/TypingInput";
import { API_HOST } from "utils";

const videoLinks = [
    { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/launch-avatar.mp4" },
]

const AVATAR_LINKS = [
    {
        "url": "https://soomuch.blob.core.windows.net/data-soomuch/WebsiteContent/seralynne/intro.mp4"
    },
    {
        "url": "https://soomuch.blob.core.windows.net/data-soomuch/WebsiteContent/Lioraelithia/lioraelithia_demo.mp4"
    },
    {
        "url": "https://soomuch.blob.core.windows.net/data-soomuch/WebsiteContent/Elarin/elarin_demo.mp4"
    },
    {
        "url": "https://soomuch.blob.core.windows.net/data-soomuch/WebsiteContent/Elaraia/elaraia_demo.mp4"
    },
    {
        "url": "https://soomuch.blob.core.windows.net/data-soomuch/WebsiteContent/Alarice/alarice_demo.mp4"
    },
    {
        "url": "https://soomuch.blob.core.windows.net/data-soomuch/WebsiteContent/Shivani/shivani_demo.mp4"
    },
    {
        "url": "https://soomuch.blob.core.windows.net/data-soomuch/WebsiteContent/Rani/rani_demo.mp4"
    },
    {
        "url": "https://soomuch.blob.core.windows.net/data-soomuch/WebsiteContent/Maryam/maryam_demo.mp4"
    },
    {
        "url": "https://soomuch.blob.core.windows.net/data-soomuch/WebsiteContent/Dfbn/dfbn_demo.mp4"
    }
]


const Chatbot = () => {
    const navigate = useNavigate();
    const videoRef = useRef(null);
    const [mobileNumber, setMobileNumber] = useState(() => {
        let storedData = "";
        try {
            storedData = JSON.parse(sessionStorage.getItem('form_data') as any)?.MOBILE_NUMBER
        } catch (err) { }
        return (storedData || '');
    });
    const [avatarCounter, setAvatarCounter] = useState(0);
    const [loader, setLoader] = useState(false);
    const [successModal, setSuccessModal] = useState<any>(false);

    const videoSufflinigPostion = Number(Number(avatarCounter) % Number(AVATAR_LINKS?.length));

    // const step1Ref = useSpotlight("");
    // const step2Ref = useSpotlight("");
    // const step3Ref = useSpotlight("");

    const handlePlay = () => {
        if (videoRef.current) {
            videoRef.current.play();
        }
    };

    const handleSubmit = async () => {
        try {
            setLoader(true);
            if (!!mobileNumber) {
                const response = await axios.post(`${API_HOST}/master/sendDemoBrochure`, {
                    dest: mobileNumber
                });
                sessionStorage.setItem('form_data', JSON.stringify({
                    "NAME": "",
                    "LANGUAGE": "",
                    "INSTITUTE_NAME": "",
                    "INSTITUTE_TYPE": "",
                    "MOBILE_NUMBER": mobileNumber,
                    "TOTAL_STRENGTH": "",
                    "OTP": "",
                    "ROLE": "",
                    "REMARKS": "",
                    "SOURCE": "COMM"
                }));
                if ([200, 201]?.includes(response?.data?.code)) {

                    setSuccessModal(successModal => ({ key: "success", message: response?.data?.message }));
                } else {
                    throw new Error(response?.data?.message)
                }
            }
        } catch (err) {
            console.log(err);
            setSuccessModal(successModal => ({ key: "error", message: err?.message }));
        } finally {
            setLoader(false);
        }
    }

    return (
        <Wrapper
            title={"Meet Your AI Virtual Admission Counselor"}
            titleSize="text-[5vh]"
            description={<span>Imagine having someone who never sleeps, never misses a lead, and always gives the perfect school tour. <br /> With our AI Virtual Counselor.</span>}
            descriptionSize="text-[2.2vh]"
            videoLinks={videoLinks}
            body={<>
                {!!successModal?.key && <SuccessModal
                    isOpen={successModal}
                    onRequestClose={() => {
                        setSuccessModal(false)
                    }}
                />}
                <div className="grid grid-cols-2 gap-4 w-full">
                    <div className="space-y-6">
                        <h2 className="text-smd_blue-normal font-manropeSB text-[4vh]">Your 24/7 Admission Expert. No Salary Needed</h2>
                        <p className={`text-[2.4vh]`}>✏️ Talk to website visitors in real-time</p>
                        <p className={`text-[2.4vh]`}>🤖 <span className="font-manropeSB">Speak in multiple languages — </span> English, Hindi, Telugu, and more....</p>
                        {/* <p className={`text-[2.4vh]`}>🎯 Choose the <span className="font-manropeSB">look & voice</span> that fits your school’s vibe</p> */}
                        <p className={`text-[2.4vh]`}>🤖 Answer parent questions, collect contact details, share brochure and  more....</p>
                        <div className="flex items-center gap-4">
                            <div className="w-[60%] py-[1.6vh] px-3 rounded-xl bg-[white] border border-smd_golden-light">
                                <TypingInput
                                    type="text"
                                    value={mobileNumber}
                                    onChange={e => setMobileNumber(e)}
                                    fullText={"Enter your WhatsApp number"}
                                    className="w-full px-4 rounded-lg border border-smd_golden-light placeholder:text-[2.2vh] text-[2.2vh] focus:outline-none"
                                />
                                {/* <input
                                    type="text"
                                    value={mobileNumber}
                                    onChange={e => setMobileNumber(e.target.value)}
                                    // placeholder={`Enter your WhatsApp number`}
                                    placeholder={placeholder}
                                    className="w-full px-4 rounded-lg border border-smd_golden-light placeholder:text-[2.2vh] text-[2.2vh] focus:outline-none"
                                /> */}
                            </div>
                            {loader ? <Img src="images/loader.gif" alt="loader" className="h-10" /> : <button onClick={handleSubmit} disabled={!mobileNumber} type="button" className="self-stretch w-fit px-6 rounded-xl bg-[#F93827] text-[white] text-[2.2vh] shadow-2xl">Send</button>}
                        </div>
                        <p className="text-[2vh]">We will send sample branding material to your WhatsApp</p>
                    </div>
                    <div className="space-y-6">
                        <div className="flex justify-center items-center gap-4">
                            <div>
                                <video
                                    src={AVATAR_LINKS?.[videoSufflinigPostion]?.url}
                                    playsInline
                                    disablePictureInPicture  // 🔒 Disables PiP across Chromium browsers
                                    controlsList="nodownload nofullscreen noplaybackrate noremoteplayback" // Optional: further restricts controls
                                    className="w-[20vh] h-[20vh] object-top object-cover bg-[white] rounded-lg blur-sm"
                                />
                            </div>
                            <div className="flex flex-col gap-6">
                                <video
                                    ref={videoRef}
                                    src={AVATAR_LINKS?.[videoSufflinigPostion + 1]?.url}
                                    playsInline
                                    disablePictureInPicture  // 🔒 Disables PiP across Chromium browsers
                                    controlsList="nodownload nofullscreen noplaybackrate noremoteplayback" // Optional: further restricts controls
                                    className="w-[30vh] h-[30vh] object-top object-cover bg-[white] rounded-lg"
                                />
                            </div>
                            <div>
                                <video
                                    src={AVATAR_LINKS?.[videoSufflinigPostion + 2]?.url}
                                    playsInline
                                    disablePictureInPicture  // 🔒 Disables PiP across Chromium browsers
                                    controlsList="nodownload nofullscreen noplaybackrate noremoteplayback" // Optional: further restricts controls
                                    className="w-[20vh] h-[20vh] object-top object-cover bg-[white] rounded-lg blur-sm"
                                />
                            </div>
                        </div>
                        <div className="flex justify-center gap-12 items-center">
                            <button onClick={() => setAvatarCounter(avatarCounter => avatarCounter - 1)} disabled={+avatarCounter < 0} type="button" className="p-2 bg-smd_white-normal border border-smd_golden-light rounded-full">
                                <Img src="images/soomuch-demo/left_arrow.svg" />
                            </button>
                            <button onClick={() => setAvatarCounter(avatarCounter => avatarCounter + 1)} type="button" className="p-2 bg-smd_white-normal border border-smd_golden-light rounded-full">
                                <Img src="images/soomuch-demo/right_arrow.svg" />
                            </button>
                        </div>
                        <div className="flex justify-center">
                            <button onClick={handlePlay} type="button" className="text-[2.2vh] flex items-center py-2 px-8 bg-smd_blue-dark text-gray-200 shadow-2xl font-light rounded-xl">
                                Play
                            </button>
                        </div>
                    </div>
                </div>
            </>}
        />
        // <div className="flex justify-center min-h-screen bg-[url(/public/images/soomuch-demo/background.svg)] bg-no-repeat bg-cover bg-center">
        //     <div className="container font-manrope p-7 flex flex-col justify-between w-full">
        //         <div className="flex">
        //             <div className="grid grid-cols-12 gap-4 w-full">
        //                 <div className="col-span-2"><Img src="images/soomuch-demo/logo.svg" /></div>
        //                 <div className="text-center self-end space-y-2 col-span-8">
        //                     <h1 className="font-raveo text-smd_blue-normal text-4xl font-[1000] leading-[120%] tracking-[-1%]">Meet Your AI Virtual Admission Counselor</h1>
        //                     <p className="text-sm">Imagine having someone who never sleeps, never misses a lead, and always gives the perfect school tour. <br />
        //                         With our AI Virtual Counselor.</p>
        //                 </div>
        //                 <div className="flex justify-end col-span-2">
        //                    <AvatarVideo videoLinks={videoLinks} />
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="grid grid-cols-2 gap-4 w-full">
        //             <div className="space-y-6">
        //                 <h2 className="text-smd_blue-normal font-manropeSB text-2xl">Your 24/7 Admission Expert. No Salary Needed</h2>
        //                 <p className={`text-md`}>✏️ Talk to website visitors in real-time</p>
        //                 <p className={`text-md`}>🤖 <span className="font-manropeSB">Speak in multiple languages — </span> English, Hindi, Telugu, and more</p>
        //                 <p className={`text-md`}>🎯 Choose the <span className="font-manropeSB">look & voice</span>that fits your school’s vibe</p>
        //                 <p className={`text-md`}>🤖 Answer parent questions, explain fees, facilities & more</p>
        //             </div>
        //             <div className="space-y-4">
        //                 <div className="flex justify-center items-center gap-4">
        //                     <div>
        //                         <video
        //                             src={AVATAR_LINKS?.[videoSufflinigPostion]?.url}
        //                             playsInline
        //                             className="w-[7rem] h-[7rem] object-top object-cover bg-[white] rounded-lg blur-sm"
        //                         />
        //                     </div>
        //                     <div className="flex flex-col gap-6">
        //                         <video
        //                             ref={videoRef}
        //                             src={AVATAR_LINKS?.[videoSufflinigPostion+1]?.url}
        //                             playsInline
        //                             className="w-[10rem] h-[10rem] object-top object-cover bg-[white] rounded-lg"
        //                         />
        //                     </div>
        //                     <div>
        //                         <video
        //                             src={AVATAR_LINKS?.[videoSufflinigPostion+2]?.url}
        //                             playsInline
        //                             className="w-[7rem] h-[7rem] object-top object-cover bg-[white] rounded-lg blur-sm"
        //                         />
        //                     </div>
        //                 </div>
        //                 <div className="flex justify-center gap-12 items-center">
        //                     <button onClick={() => setAvatarCounter(avatarCounter => avatarCounter - 1)} disabled={+avatarCounter < 0} type="button" className="p-2 bg-smd_white-normal border border-smd_golden-light rounded-full">
        //                         <Img src="images/soomuch-demo/left_arrow.svg" />
        //                     </button>
        //                     <button onClick={() => setAvatarCounter(avatarCounter => avatarCounter + 1)} type="button" className="p-2 bg-smd_white-normal border border-smd_golden-light rounded-full">
        //                         <Img src="images/soomuch-demo/right_arrow.svg" />
        //                     </button>
        //                 </div>
        //                 <div className="flex justify-center">
        //                     <button onClick={handlePlay} type="button" className="flex items-center py-2 px-6 bg-smd_blue-dark text-[white] rounded-xl">
        //                         Play
        //                     </button>
        //                 </div>
        //             </div>
        //         </div>
        //         <Stepper />
        //     </div>
        // </div>
    );
}

export default Chatbot;